/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Dispatch, useEffect, useState } from 'react'

import Label from 'live/components/forms/ui/label'
import authorization from 'live/services/authorization'
import i18n from 'live/services/i18n'

import { EntityEditorModal } from '../../../../../generic'
import { IBowtie } from '../../../../../types'
import { IConsequenceEditor, IThreatEditor } from '../../BowtieEditor'
import { ThreatConsequenceModal } from './components'
import { InfoContainer } from './styles'

type IProps = {
    handleClose: () => void
    data: IBowtie
    item: IThreatEditor | IConsequenceEditor
    isOpen: boolean
    borderColor: string
    type: IType
    handleChange: (data: IBowtie) => void
    setSelected: Dispatch<React.SetStateAction<ITempThCq>>
}

type IType = 'threat' | 'consequence'
interface ITempThCq {
    item: IThreatEditor | IConsequenceEditor
    type: IType
}

export const ThreatConsequenceAssignModal: React.FC<IProps> = props => {
    const { item, handleClose, isOpen, borderColor, type, data, setSelected, handleChange } = props
    const [isEditing, setIsEditing] = useState(false)
    const bowtieAdmin = authorization.superAdmin || authorization.Permission.BOWTIE_ADMIN

    const index = findIndex()

    const [tempItem, setTempItem] = React.useState<IThreatEditor | IConsequenceEditor>()

    function findIndex(): number {
        function handleFind(thcnq: IThreatEditor | IConsequenceEditor): boolean {
            if (thcnq.id != null && item?.id != null) {
                return item.id === thcnq.id
            }

            return thcnq.uid === item?.uid
        }
        if (type === 'threat') {
            return data?.topEvent.threats.findIndex(handleFind)
        } else {
            return data?.topEvent.consequences.findIndex(handleFind)
        }
    }

    const handleItemChange = newItem => {
        if (item && index >= 0) {
            if (type === 'threat') {
                data.topEvent.threats[index] = newItem
                handleChange(data)
                setSelected({ item: data.topEvent.threats[index], type: 'threat' })
            } else {
                data.topEvent.consequences[index] = newItem
                handleChange(data)
                setSelected({ item: data.topEvent.consequences[index], type: 'consequence' })
            }
        }
    }

    useEffect(() => {
        if (isOpen && Object.values(item).every(x => x === (undefined || null) || x === '')) setIsEditing(true)
        else if (item) setTempItem(item)
    }, [item])

    useEffect(() => {
        if (tempItem && Object.keys(item).filter(k => item[k] !== tempItem[k]).length > 0) handleItemChange(tempItem)
    }, [tempItem])

    useEffect(() => {
        if (!isOpen) {
            setIsEditing(false)
        } else {
            if (item?.name?.trim().length === 0) {
                setIsEditing(true)
            }
        }
    }, [isOpen])

    return (
        isOpen && (
            <>
                <EntityEditorModal
                    handleClose={handleClose}
                    isOpen={isOpen}
                    borderColor={borderColor}
                    headerTitle={type?.toLocaleUpperCase()}
                    headerSubtitle={item?.id ? `${type === 'threat' ? 'TH' : 'CQ'}${item.id}#` : ''}
                >
                    {bowtieAdmin && !isEditing ? (
                        <InfoContainer>
                            <div className="info-title info-row">
                                <Label>{tempItem?.name}</Label>
                                <i className="fas fa-edit" onClick={() => setIsEditing(true)} />
                            </div>

                            <div className="info-row info">
                                <div className="key">
                                    {type === 'threat' ? i18n('Initial Frequency') : i18n('Threshold Frequency')}
                                </div>
                                <div className="value">
                                    {type === 'threat'
                                        ? (tempItem as IThreatEditor)?.initialFrequency ?? '---'
                                        : (tempItem as IConsequenceEditor)?.thresholdFrequency ?? '---'}
                                </div>
                            </div>
                        </InfoContainer>
                    ) : (
                        <ThreatConsequenceModal type={type} item={tempItem} handleChange={setTempItem} />
                    )}
                </EntityEditorModal>
            </>
        )
    )
}
